import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

export default function HydrogenLayout() {
    return (
        <main className="flex min-h-screen flex-grow bg-background text-foreground">
            <Sidebar className="fixed hidden xl:block" />
            <div className="flex w-full flex-col xl:ms-[270px] xl:w-[calc(100%-270px)] 2xl:ms-72 2xl:w-[calc(100%-288px)]">
                <Header />
                <div className="flex flex-grow flex-col px-4 pb-6 pt-2 md:px-5 lg:px-6 lg:pb-8">
                    <Outlet />
                </div>
            </div>
        </main>
    );
}
